(function () {
  const Core = window.FoundiFunnelCore;
  if (!Core || customElements.get('foundi-funnel')) return;

  customElements.define('foundi-funnel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-foundi-config]').textContent);
      this.form = this.querySelector('.foundi-offer-form');
      this.currency = this.dataset.currency || 'CAD';
      this.locale = this.dataset.locale || 'en-CA';
      this.bindOffer();
      this.bindGallery();
      this.bindPostalChecker();
      this.bindSticky();
      this.syncPurchase();
    }

    money(cents) {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        currencyDisplay: 'code',
      }).format(cents / 100);
    }

    bindOffer() {
      if (!this.form) return;
      this.form.addEventListener('change', (event) => {
        if (event.target.matches('[data-foundi-size]')) this.syncPurchase();
        if (event.target.matches('[name="selling_plan"], [name="quantity"]')) this.updateTotal();
      });
      this.form.addEventListener('input', (event) => {
        if (event.target.matches('[name="quantity"]')) this.updateTotal();
      });
      this.form.addEventListener('click', (event) => {
        const step = event.target.closest('[data-foundi-step]');
        if (!step) return;
        const quantity = this.form.querySelector('[name="quantity"]');
        quantity.value = Math.max(1, Math.min(12, (Number(quantity.value) || 1) + Number(step.dataset.foundiStep)));
        this.updateTotal();
      });
    }

    syncPurchase() {
      if (!this.form) return;
      const variant = this.form.querySelector('[data-foundi-size]:checked');
      if (!variant) return;
      this.form.querySelectorAll('[data-foundi-purchase-for]').forEach((group) => {
        const active = group.dataset.foundiPurchaseFor === variant.value;
        group.hidden = !active;
        group.disabled = !active;
        if (!active) return;
        const plans = Array.from(group.querySelectorAll('[name="selling_plan"]')).filter((input) => input.value);
        const preferred = Core.defaultPurchaseValue({ isSample: false, planIds: plans.map((input) => input.value) });
        const choice = group.querySelector(`[name="selling_plan"][value="${CSS.escape(preferred)}"]`) || group.querySelector('[name="selling_plan"]');
        if (choice) choice.checked = true;
      });
      this.updateTotal();
    }

    updateTotal() {
      const group = this.form.querySelector('[data-foundi-purchase-for]:not([hidden])');
      const plan = group && group.querySelector('[name="selling_plan"]:checked');
      const quantity = Math.max(1, Number(this.form.querySelector('[name="quantity"]').value) || 1);
      if (!plan) return;
      const total = Number(plan.dataset.charge) * quantity;
      this.form.querySelector('[data-foundi-total]').textContent = this.money(total);
      const submit = this.form.querySelector('[type="submit"]');
      submit.firstChild.textContent = plan.value ? 'Add monthly delivery to bag ' : 'Add to bag ';
      this.updateSticky(total, plan.value !== '');
    }

    bindGallery() {
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-foundi-image]');
        if (!thumb) return;
        const image = this.querySelector('.foundi-offer__image img');
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = thumb.dataset.foundiImage;
        image.alt = thumb.dataset.foundiAlt || '';
        this.querySelectorAll('[data-foundi-image]').forEach((button) => button.setAttribute('aria-pressed', String(button === thumb)));
      });
    }

    bindPostalChecker() {
      const checker = this.querySelector('[data-foundi-postal-form]');
      if (!checker) return;
      const input = checker.querySelector('[data-foundi-postal]');
      const result = checker.querySelector('[data-foundi-postal-result]');
      const sampleForm = this.querySelector('[data-foundi-sample-form]');
      const sampleButton = sampleForm && sampleForm.querySelector('[type="submit"]');
      const prefixField = sampleForm && sampleForm.querySelector('[data-foundi-prefix-field]');
      checker.addEventListener('submit', (event) => {
        event.preventDefault();
        const prefix = Core.normalizePostalPrefix(input.value);
        const eligible = Core.isSampleEligible(input.value, this.config.eligiblePrefixes);
        if (prefix.length < 3) {
          result.dataset.state = 'ineligible';
          result.textContent = 'Enter the first three characters—or your full Canadian postal code.';
        } else if (!eligible) {
          result.dataset.state = 'ineligible';
          result.textContent = 'We are not delivering samples to this postal area yet. Join the list below and we will let you know when the area expands.';
        } else if (!this.config.localDeliveryLive) {
          result.dataset.state = 'eligible';
          result.textContent = 'Your area is on our founder-delivery route. Ordering will open here as soon as checkout delivery is activated.';
        } else {
          result.dataset.state = 'eligible';
          result.textContent = 'Good news—your address is in our free founder-delivery area.';
        }
        if (prefixField) prefixField.value = prefix;
        if (sampleForm) sampleForm.hidden = !eligible;
        if (sampleButton) sampleButton.disabled = !(eligible && this.config.localDeliveryLive);
      });
    }

    bindSticky() {
      this.sticky = this.querySelector('[data-foundi-sticky]');
      this.offer = this.querySelector('[data-foundi-offer]');
      if (!this.sticky || !this.offer) return;
      const refresh = () => {
        const rect = this.offer.getBoundingClientRect();
        this.sticky.hidden = rect.top < window.innerHeight && rect.bottom > 0;
        document.body.style.paddingBottom = this.sticky.hidden ? '' : `${this.sticky.offsetHeight}px`;
      };
      window.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      refresh();
    }

    updateSticky(total, subscription) {
      if (!this.sticky) return;
      const price = this.sticky.querySelector('[data-foundi-sticky-price]');
      if (price) price.textContent = `${this.money(total)}${subscription ? ' monthly' : ' one-time'}`;
    }
  });
})();
